// import React, { useState } from 'react';
// import '../../../styles/Header-css/ServicePartner/PartnerVerification/PartnerVerification.css'; 
// import { FaUser, FaTools, FaIdCard, FaCheckCircle, FaToolbox } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';

// // Step components
// import ProfileStep from './ProfileSetup';
// import SkillsStep from './SkillsStep';
// import KycStep from './KycStep';
// // import Verification from'./Verification ';
// import R2rKitStep from './R2rKitStep';
// import SuccessStep from './SuccessStep';

// const stepsData = [
//   { id: 'profile', icon: <FaUser />, label: 'Profile' },
//   { id: 'skills', icon: <FaTools />, label: 'Services' }, // Add this step
//   { id: 'kyc', icon: <FaIdCard />, label: 'KYC' },
//   // { id: 'verification', icon: <FaCheckCircle />, label: 'Verification' },
//   { id: 'r2r-kit', icon: <FaToolbox />, label: 'R2R Kit' },
// ];

// const PartnerVerification = () => {
//   const [currentStep, setCurrentStep] = useState(0);
//   const [formData, setFormData] = useState({
//     accountType: '',
//     fullname: '',
//     phone: '',
//     // Current Location fields (separate section)
//     currentLocation: '',
//     latitude: '',
//     longitude: '',
//     // Address Details fields (manual input)
//     homeFlat: '',
//     street: '',
//     village: '',
//     landmark: '',
//     // Skills field
//     selectedSkills: [], // Add this field
//     // Existing KYC fields
//     idType: '',
//     idNumber: '',
//     idUpload: null,
//   });
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();

//   // Handle form field changes
//   const handleInputChange = (e) => {
//     const { name, value, type, files } = e.target;
//     setFormData(prev => ({ 
//       ...prev, 
//       [name]: type === 'file' ? files[0] : value 
//     }));
//   };

//   // Validate current step
//   const validateStep = (stepIndex) => {
//     const newErrors = {};
    
//     if (stepIndex === 0) {
//       // Profile step validation
//       if (!formData.accountType) newErrors.accountType = 'Please select account type';
//       if (!formData.fullname.trim()) newErrors.fullname = 'Please enter your full name';
//       if (!formData.phone.trim()) newErrors.phone = 'Please enter a valid phone number';
      
//       // Current Location validation (now mandatory)
//       if (!formData.currentLocation.trim()) newErrors.currentLocation = 'Please detect your current location using the location button';
      
//       // Address details validation (mandatory)
//       if (!formData.homeFlat.trim()) newErrors.homeFlat = 'Please enter home/flat number';
//       if (!formData.street.trim()) newErrors.street = 'Please enter street name';
//       if (!formData.village.trim()) newErrors.village = 'Please enter village/town/city';
      
//       // Phone number validation (basic)
//       const phoneRegex = /^[0-9]{10,15}$/;
//       if (formData.phone && !phoneRegex.test(formData.phone.replace(/\D/g, ''))) {
//         newErrors.phone = 'Please enter a valid phone number';
//       }
//     }
    
//     // Skills step validation
//     if (stepIndex === 1) {
//       if (!formData.selectedSkills || formData.selectedSkills.length === 0) {
//         newErrors.selectedSkills = 'Please select at least one service';
//       }
//     }
    
//     // KYC step validation
//     if (stepIndex === 2) {
//       if (!formData.idType) newErrors.idType = 'Please select ID type';
//       if (!formData.idNumber.trim()) newErrors.idNumber = 'Please enter ID number';
//       if (!formData.idUpload) newErrors.idUpload = 'Please upload ID document';
      
//       // ID number validation based on type
//       if (formData.idType && formData.idNumber) {
//         const idNumber = formData.idNumber.trim();
//         switch (formData.idType) {
//           case 'aadhaar':
//             if (!/^\d{12}$/.test(idNumber)) {
//               newErrors.idNumber = 'Aadhaar number must be 12 digits';
//             }
//             break;
//           case 'pan':
//             if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idNumber)) {
//               newErrors.idNumber = 'PAN number must be 10 characters (e.g., ABCDE1234F)';
//             }
//             break;
//           case 'driving':
//             if (idNumber.length < 5) {
//               newErrors.idNumber = 'Please enter a valid driving license number';
//             }
//             break;
//           case 'voter':
//             if (idNumber.length < 5) {
//               newErrors.idNumber = 'Please enter a valid voter ID number';
//             }
//             break;
//           case 'passport':
//             if (idNumber.length < 8) {
//               newErrors.idNumber = 'Please enter a valid passport number';
//             }
//             break;
//         }
//       }
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNext = () => {
//     if (validateStep(currentStep)) {
//       if (currentStep < stepsData.length) {
//         setCurrentStep(prev => prev + 1);
//       }
//     }
//   };

//   const handleBack = () => {
//     if (currentStep > 0) {
//       setCurrentStep(prev => prev - 1);
//     }
//   };

//   // Save profile and navigate to profile page
//   const handleGoToProfile = () => {
//     localStorage.setItem('partnerProfile', JSON.stringify(formData));
//     navigate('/partner-profile');
//   };

//   // Render step content
//   const renderStepContent = () => {
//     switch (currentStep) {
//       case 0:
//         return (
//           <ProfileStep 
//             data={formData} 
//             onDataChange={handleInputChange} 
//             onNext={handleNext} 
//             errors={errors} 
//           />
//         );
//       case 1:
//         return (
//           <SkillsStep 
//             data={formData} 
//             onDataChange={handleInputChange} 
//             onBack={handleBack} 
//             onNext={handleNext} 
//             errors={errors} 
//           />
//         );
//       case 2:
//         return (
//           <KycStep 
//             data={formData} 
//             onDataChange={handleInputChange} 
//             onBack={handleBack} 
//             onNext={handleNext} 
//             errors={errors} 
//           />
//         );
//       // case 3:
//       //   return (
//       //     <Verification 
//       //       onBack={handleBack} 
//       //       onNext={handleNext} 
//       //     />
//       //   );
//       case 3:
//         return (
//           <R2rKitStep 
//             data={formData} 
//             onDataChange={handleInputChange} 
//             onBack={handleBack} 
//             onNext={handleNext} 
//             errors={errors} 
//           />
//         );
//       case 4:
//         return <SuccessStep onGoToDashboard={handleGoToProfile} />;
//       default:
//         return null;
//     }
//   };

//   const progressPercentage = currentStep > 0 ? (currentStep / (stepsData.length - 1)) * 100 : 0;

//   return (
//     <div className="onboarding-page">
//       <div className="onboarding-container">
//         <div className="onboarding-header">
//           <h1>Ready2Rental</h1>
//           <p>Partner App</p>
//         </div>
        
//         {currentStep < 5 && (
//           <div className="onboarding-progress-container">
//             <div className="onboarding-progress-steps">
//               <div className="onboarding-progress-connector">
//                 <div className="onboarding-progress-active" style={{ width: `${progressPercentage}%` }}></div>
//               </div>
//               {stepsData.map((step, index) => (
//                 <div 
//                   key={step.id} 
//                   className={`onboarding-step ${index === currentStep ? 'onboarding-step-active' : index < currentStep ? 'onboarding-step-completed' : 'onboarding-step-inactive'}`}
//                 >
//                   <div className="onboarding-step-icon">{step.icon}</div>
//                   <div className="onboarding-step-text">{step.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
        
//         <div className="onboarding-content-area">
//           {renderStepContent()}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PartnerVerification;

import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ProfileStep from "./ProfileSetup";
import SkillsStep from "./SkillsStep";
import KycStep from "./KycStep";
import R2rKitStep from "./R2rKitStep";
import SuccessStep from "./SuccessStep";
import VerificationPending from "./VerificationPending";
import { FaUser, FaTools, FaIdCard, FaToolbox } from "react-icons/fa";
import "../../../styles/Header-css/ServicePartner/PartnerVerification/PartnerVerification.css";

const stepsData = [
  { id: "profile", icon: <FaUser />, label: "Profile" },
  { id: "skills", icon: <FaTools />, label: "Services" },
  { id: "kyc", icon: <FaIdCard />, label: "KYC" },
  { id: "worklocation", icon: <FaToolbox />, label: "Work Location" },
];

export default function PartnerVerification() {
  const [params] = useSearchParams();
  const entryStep = Number(params.get("step")) || 0;
  const [currentStep, setCurrentStep] = useState(entryStep);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    accountType: "",
    fullname: "",
    phone: "",
    currentLocation: "",
    latitude: "",
    longitude: "",
    homeFlat: "",
    street: "",
    village: "",
    landmark: "",
    selectedSkills: [],
    idType: "",
    idNumber: "",
    idUpload: null,
  });
  const [errors, setErrors] = useState({});

 const handleInputChange = (eOrObject) => {
  // Case 1: called from an input event
  if (eOrObject?.target) {
    const { name, value, type, files } = eOrObject.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  } 
  // Case 2: called directly with an object
  else if (typeof eOrObject === "object") {
    setFormData(prev => ({
      ...prev,
      ...eOrObject,
    }));
  }
};



  // validation logic preserved exactly (copy from your earlier validateStep)
  const validateStep = (stepIndex) => {
    const newErrors = {};
    if (stepIndex === 0) {
      if (!formData.accountType) newErrors.accountType = 'Please select account type';
      if (!formData.fullname.trim()) newErrors.fullname = 'Please enter your full name';
      if (!formData.phone.trim()) newErrors.phone = 'Please enter a valid phone number';
      if (!formData.currentLocation.trim()) newErrors.currentLocation = 'Please detect your current location';
      if (!formData.homeFlat.trim()) newErrors.homeFlat = 'Please enter home/flat number';
      if (!formData.street.trim()) newErrors.street = 'Please enter street name';
      if (!formData.village.trim()) newErrors.village = 'Please enter village/town/city';
      const phoneRegex = /^[0-9]{10,15}$/;
      if (formData.phone && !phoneRegex.test(formData.phone.replace(/\D/g,''))) newErrors.phone = 'Please enter a valid phone number';
    }
    if (stepIndex === 1) {
      if (!formData.selectedSkills || formData.selectedSkills.length === 0) newErrors.selectedSkills = 'Please select at least one service';
    }
    if (stepIndex === 2) {
      if (!formData.idType) newErrors.idType = 'Please select ID type';
      if (!formData.idNumber.trim()) newErrors.idNumber = 'Please enter ID number';
      if (!formData.idUpload) newErrors.idUpload = 'Please upload ID document';
      if (formData.idType && formData.idNumber) {
        const idNumber = formData.idNumber.trim();
        switch (formData.idType) {
          case 'aadhaar':
            if (!/^\d{12}$/.test(idNumber)) newErrors.idNumber = 'Aadhaar number must be 12 digits';
            break;
          case 'pan':
            if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idNumber)) newErrors.idNumber = 'PAN number must be 10 characters (e.g., ABCDE1234F)';
            break;
          default: break;
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (validateStep(currentStep)) setCurrentStep(prev => prev + 1);
  };
  const handleBack = () => { if (currentStep > 0) setCurrentStep(prev => prev - 1); };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return <ProfileStep data={formData} onDataChange={handleInputChange} onNext={handleNext} errors={errors} />;
      case 1:
        return <SkillsStep data={formData} onDataChange={handleInputChange} onBack={handleBack} onNext={handleNext} errors={errors} />;
      case 2:
        return <KycStep data={formData} onDataChange={handleInputChange} onBack={handleBack} onNext={handleNext} errors={errors} />;
      case 3:
        return <R2rKitStep data={formData} onDataChange={handleInputChange} onBack={handleBack} onNext={handleNext} errors={errors} />;
      case 4:
        return <VerificationPending data={formData} onDataChange={handleInputChange} onBack={handleBack} onNext={handleNext} errors={errors} />;
      case 5:
        return <SuccessStep onGoToDashboard={() => navigate("/partner-profile")} />;
      default:
        return null;
    }
  };

  const progressPercentage = currentStep > 0 ? (currentStep / (stepsData.length - 1)) * 100 : 0;

  return (
    <div className="onboarding-page">
      <div className="onboarding-container">
        <div className="onboarding-header">
          <h1>Ready2Rental</h1>
          <p>Partner App</p>
        </div>

        <div className="onboarding-progress-container">
          <div className="onboarding-progress-connector">
            <div className="onboarding-progress-active" style={{ width: `${progressPercentage}%` }} />
          </div>

          <div className="onboarding-progress-steps">
            {stepsData.map((step, index) => (
              <div key={step.id} className={`onboarding-step ${index === currentStep ? 'onboarding-step-active' : index < currentStep ? 'onboarding-step-completed' : 'onboarding-step-inactive'}`}>
                <div className="onboarding-step-icon">{step.icon}</div>
                <div className="onboarding-step-text">{step.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="onboarding-content-area">{renderStepContent()}</div>
      </div>
    </div>
  );
}
